import axios from "axios";
import config from "../config/environment";

// Used only for pre-auth endpoints (magic-login, OTP). A 401 here means
// login failed, not session expiry — no triggerLogout interceptor needed.
const axiosClient = axios.create({
  baseURL: config.contentApiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosClient;
